/* Sindhu Reddy — header behaviour (sr-header section) */
(() => {
  if (window.srHeader) return;
  window.srHeader = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let cleanup = null;

  function init() {
    if (cleanup) cleanup();
    const hd = document.querySelector('[data-srhd]');
    if (!hd) return;
    const section = hd.closest('.shopify-section') || hd;
    const drawer = document.getElementById(hd.dataset.drawer);
    const offs = [];
    const on = (el, ev, fn, opt) => { if (!el) return; el.addEventListener(ev, fn, opt); offs.push(() => el.removeEventListener(ev, fn, opt)); };

    /* offers rotation */
    const offers = [...hd.querySelectorAll('.srhd-offers p')];
    let oi = 0, timer = null;
    if (offers.length > 1 && !reduce) timer = setInterval(() => {
      offers[oi].classList.remove('is-active');
      oi = (oi + 1) % offers.length;
      offers[oi].classList.add('is-active');
    }, (+hd.dataset.offerSpeed || 4) * 1000);

    /* sticky: the offers strip scrolls away, the bar stays; hides on scroll down */
    const offersEl = hd.querySelector('.srhd-offers');
    const hideOnScroll = hd.dataset.hide === 'true';
    let hidden = false, lastY = scrollY;
    const busy = () => hd.classList.contains('search-open') || !!hd.querySelector('.srhd-has-mega.is-open') ||
      (drawer && drawer.classList.contains('is-open')) ||
      /mini-cart--(open|opening)/.test(document.body.className);
    const place = () => {
      const oh = offersEl ? offersEl.offsetHeight : 0;
      section.style.top = (hidden ? -section.offsetHeight : -oh) + 'px';
    };
    const onScroll = () => {
      const y = scrollY;
      hd.classList.toggle('is-scrolled', y > 10);
      if (hideOnScroll) {
        const want = y > lastY + 6 && y > 600 && !busy() ? true : (y < lastY - 6 || y < 600 || busy()) ? false : hidden;
        if (want !== hidden) { hidden = want; place(); }
      }
      lastY = y;
    };
    on(window, 'scroll', onScroll, { passive: true });
    on(window, 'resize', place);
    place(); onScroll();

    /* mega menu */
    hd.querySelectorAll('.srhd-has-mega').forEach(m => {
      const b = m.querySelector('button');
      on(b, 'click', () => {
        const open = !m.classList.contains('is-open');
        m.classList.toggle('is-open', open);
        b.setAttribute('aria-expanded', String(open));
      });
    });
    const closeMegas = () => hd.querySelectorAll('.srhd-has-mega.is-open').forEach(m => { m.classList.remove('is-open'); m.querySelector('button').setAttribute('aria-expanded', 'false'); });
    on(document, 'click', e => { if (!e.target.closest('.srhd-has-mega')) closeMegas(); });

    /* search */
    const sBtn = hd.querySelector('.srhd-tool--search');
    const sInput = hd.querySelector('.srhd-search input[type="search"]');
    on(sBtn, 'click', () => {
      const open = !hd.classList.contains('search-open');
      hd.classList.toggle('search-open', open);
      sBtn.setAttribute('aria-expanded', String(open));
      if (open) { hidden = false; place(); setTimeout(() => sInput && sInput.focus(), 60); }
    });

    /* drawer */
    const burger = hd.querySelector('.srhd-burger');
    const setDrawer = open => {
      if (!drawer) return;
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      burger && burger.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) { const c = drawer.querySelector('.srhd-drawer__close'); c && c.focus(); }
    };
    on(burger, 'click', () => setDrawer(true));
    if (drawer) {
      on(drawer.querySelector('.srhd-drawer__close'), 'click', () => { setDrawer(false); burger && burger.focus(); });
      on(drawer, 'click', e => { if (e.target === drawer || e.target.closest('nav > a, .srhd-drawer__group a')) setDrawer(false); });
    }
    on(document, 'keydown', e => {
      if (e.key !== 'Escape') return;
      closeMegas();
      if (drawer && drawer.classList.contains('is-open')) { setDrawer(false); burger && burger.focus(); }
      if (hd.classList.contains('search-open')) { hd.classList.remove('search-open'); sBtn && sBtn.setAttribute('aria-expanded', 'false'); }
    });

    /* bag count — the theme re-renders #cart-icon-bubble after every cart change; mirror its number */
    const src = document.getElementById('cart-icon-bubble');
    const counts = [...document.querySelectorAll('[data-srhd-count]')];
    const sync = n => counts.forEach(c => { c.textContent = n > 99 ? '99+' : String(n); c.hidden = !n; });
    let mo = null;
    if (src && counts.length) {
      mo = new MutationObserver(() => {
        const bubble = src.querySelector('.cart-count-bubble');
        if (!bubble) return sync(0);
        if (bubble.classList.contains('cart-count-bubble--dot')) return sync(100);
        const n = parseInt((bubble.querySelector('[aria-hidden]') || bubble).textContent, 10);
        sync(isNaN(n) ? 0 : n);
      });
      mo.observe(src, { childList: true, subtree: true, characterData: true });
    }
    const refresh = () => fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(r => r.json()).then(c => sync(c.item_count)).catch(() => {});
    on(document, 'cart:updated', refresh);
    on(window, 'pageshow', e => { if (e.persisted) refresh(); });

    cleanup = () => { offs.forEach(f => f()); clearInterval(timer); mo && mo.disconnect(); document.documentElement.style.overflow = ''; section.style.top = ''; };
  }

  init();
  document.addEventListener('shopify:section:load', e => { if (e.target.querySelector('[data-srhd]')) init(); });
  document.addEventListener('shopify:block:select', e => {
    const m = e.target.closest && e.target.closest('.srhd-has-mega');
    if (m) m.classList.add('is-open');
  });
  document.addEventListener('shopify:block:deselect', e => {
    const m = e.target.closest && e.target.closest('.srhd-has-mega');
    if (m) m.classList.remove('is-open');
  });
})();
